import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { CartDetailViewModel } from '../../../../models/cart-item.model';
import { CheckoutSummaryViewModel } from '../../../../models/check-out.model';
import { CurrentUserModel } from '../../../../models/account-ledger.model';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-item-summary',
  templateUrl: './item-summary.component.html',
  styleUrls: ['./item-summary.component.css']
})
export class ItemSummaryComponent implements OnInit {

  @Input() cartDetails: CartDetailViewModel[];
  @Input() checkoutSummary: CheckoutSummaryViewModel;

  subTotal = 0;
  displayedColumns: string[] = ['Description', 'Price', 'Qty', 'Subtotal'];
  public currentUserModel: CurrentUserModel;

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
    });

    // reorder array make sure that donation item at the bottom
    this.cartDetails = this.cartDetails.sort((a, b) => a.stockCode.toLowerCase().indexOf('donation') < b.stockCode.toLowerCase().indexOf('donation') ? -1 : 1);
    
    if (this.checkoutSummary.payment) {
      const totalPrice = this.checkoutSummary.payment.totalAmount.replace(/[,$]/g,'');
      const tax = this.checkoutSummary.payment.cartTax.replace(/[,$]/g, '');

      this.subTotal = Number(totalPrice) - Number(tax);
      
    }

  }

}
